import { View, Text, Image } from 'react-native'
import React, { useEffect, useState } from 'react'
import globalInfo from '../globalInfo';

const Online = () =>{
	const websiteUrl = 'https://quedepp.santitorrabadella.com/'
	const dataOnline = websiteUrl + 'dataOnline.json';
	const status = websiteUrl + 'status.json'

	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Use an async function to fetch the data
		const fetchData = async () => {
		  try {
			const response = await fetch(status);
			const json = await response.json();
			setData(json); // Set the fetched data in the state
			setIsLoading(false); // Set isLoading to false when data is fetched
		  } catch (error) {
			console.error(error);
		  }
		};
	
		fetchData(); // Call the fetchData function when the component mounts
	}, []);

	console.log(data)

	let howManyButtons = data ? (data.info.stableVersion === globalInfo().stableVersion ? "Ya tienes la última versión de la aplicación" : "Has de actualizar la aplicación") : undefined;
	console.log(howManyButtons)
	//ahora imprime undefined porque en el server no existe .infos

	return (
		<View>
			{
				isLoading ? (
					<Image style={{ width: 400, height: 400 * 0.6 }} source={require('./../img/loading.gif')} />
				) : (
					<Text>{howManyButtons}</Text>
				)
			}
		</View>
	)
}

export default Online